import axiosInstance from './axiosInstance';

// Fetches the currently logged-in driver's own profile.
export async function getDriverProfile() {
  const response = await axiosInstance.get('/drivers/get-driver.php');
  return response.data;
}




export async function changePassword(currentPassword, newPassword) {
  const response = await axiosInstance.post('/drivers/change-password.php', {
    current_password: currentPassword,
    new_password: newPassword,
  });
  return response.data;
}